/**
 * Error type definitions for centralized error handling
 */

export enum ErrorType {
  AUTH_ERROR = 'AUTH_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
  FIREBASE_ERROR = 'FIREBASE_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  PERMISSION_ERROR = 'PERMISSION_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export interface AppError {
  type: ErrorType;
  message: string;
  originalError?: Error;
  code?: string;
  details?: Record<string, any>;
}

export class AuthError extends Error implements AppError {
  type = ErrorType.AUTH_ERROR;
  code?: string;
  details?: Record<string, any>;

  constructor(message: string, code?: string, details?: Record<string, any>) {
    super(message);
    this.name = 'AuthError';
    this.code = code;
    this.details = details;
  }
}

export class NetworkError extends Error implements AppError {
  type = ErrorType.NETWORK_ERROR;
  code?: string;
  details?: Record<string, any>;

  constructor(message: string, code?: string, details?: Record<string, any>) {
    super(message);
    this.name = 'NetworkError';
    this.code = code;
    this.details = details;
  }
}

export class FirebaseError extends Error implements AppError {
  type = ErrorType.FIREBASE_ERROR;
  code?: string;
  details?: Record<string, any>;

  constructor(message: string, code?: string, details?: Record<string, any>) {
    super(message);
    this.name = 'FirebaseError';
    this.code = code;
    this.details = details;
  }
}

export class ValidationError extends Error implements AppError {
  type = ErrorType.VALIDATION_ERROR;
  code?: string;
  details?: Record<string, any>;

  constructor(message: string, code?: string, details?: Record<string, any>) {
    super(message);
    this.name = 'ValidationError';
    this.code = code;
    this.details = details;
  }
}

export class PermissionError extends Error implements AppError {
  type = ErrorType.PERMISSION_ERROR;
  code?: string;
  details?: Record<string, any>;

  constructor(message: string, code?: string, details?: Record<string, any>) {
    super(message);
    this.name = 'PermissionError';
    this.code = code;
    this.details = details;
  }
}
